// JS
require('jquery');

//
// ファイル選択フィールドをBootstrap風にする
//
$(document).on('turbolinks:load', () => {
  const btn = document.getElementById('order-payment-form-btn');
  if (!btn) return;

  // console.debug(`STRIPE_PUBLIC_KEY: ${btn.getAttribute('data-pubKey')}`);

	// const handler = StripeCheckout.configure({
  //   //StripeのAPIキーを引っ張ってくる
  //   key: btn.getAttribute('data-pubKey'),
  //   locale: 'jp', //言語の設定（autoの場合、ユーザのブラウザ規定言語が呼び出される）
  //   currency: 'jpy',
  //   // image: "images/logo/logo.gif", // もしstripe checkoutのフォーム上部に画像を入れたい場合はここで指定する
  //   panelLabel: "{{amount}}のお支払い", //checkoutボタンの表示文字、{{amount}}の中に金額が入る
  //   allowRememberMe: true, //RememberMeを使いたい場合はここをtrueにする
  //   token: function(token, arg) { //ここでstripeTokenとstripeEmailに値を入れてsubmitする
  //     console.debug('token:', token);
  //     console.debug('arg:', arg);

  //     document.getElementById('stripe_token').value = token.id;

  //     document.forms[0].submit();
  //   }
  // });

  //Stripe Checkoutのフォームに表示される情報をここで指定する
  btn.addEventListener('click', function (e) {
    let error = false;
    let errorMessages = [];

    // modalのあとにsubmit(validation)が走ってしまうためjsで事前にvalidationチェックをする
    // 出願人チェック
    if($('select[id=order_applicant_id]').val() == ''){
      error = true;
      errorMessages.push('出願人を選択してください。');
    }

    // 契約書に同意チェック
    if(!$('input[id=order_agreement]').is(':checked')){
      error = true;
      errorMessages.push('契約書に同意してください。');
    }

    if(error) {
      alert(errorMessages.join('\n'));
      e.preventDefault();
      return
    }

    // 請求書払いだったらstripe modalを表示しない
    const isBill = $("#order_payment_method_bill").is(":checked")
    if (isBill) {
      e.preventDefault();
      document.forms[0].submit();
      return
    }

    // handler.open({
    //   email: this.getAttribute('data-email'),
    //   name: 'IP FORWARD商標出願サービス費用',
    //   description: 'お支払いを完了してください',
    //   amount: btn.getAttribute('data-amount'),
    // });

    // e.preventDefault();
  })
})
